import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import {
	DescriptionWithImage,
	PaddingContainer,
	WidthContainer,
} from '@components';
import VideoBackgroundImage from '@static/images/figures/spark-video-bg.webp';
import { caseStudies } from '@store/IoTData';

import * as styles from './CaseStudies.module.scss';

export const CaseStudies: React.FC = () => {
	return (
		<div>
			<PaddingContainer className="white-bg pb-0">
				<WidthContainer>
					<h2 className="font-size-medium-title">IoT protocols & standards</h2>
				</WidthContainer>
			</PaddingContainer>
			{caseStudies.map((caseStudy) =>
				caseStudy.hasVideo ? (
					<PaddingContainer key={caseStudy.title} className="white-bg">
						<WidthContainer>
							<div className="row no-gutters">
								<div className="col12 col-md-6">
									<div className={styles.content}>
										<img
											className="mb-3"
											src={caseStudy.leadingIcon}
											alt={caseStudy.title}
										/>
										<p className="font-size-md font-600 orange-font mb-2">
											{caseStudy.title}
										</p>
										<p className="font-size-sm line-height-26 limit-text mb-3">
											{caseStudy.description}
										</p>
										<Link
											to={caseStudy.link}
											className={classNames(
												styles.link,
												'bttn bttn-orange-border link'
											)}
										>
											See case study with this technology
										</Link>
									</div>
								</div>
								<div
									className={classNames(
										styles.videoContainer,
										'col-12 col-md-6 d-flex align-items-center justify-content-center pt-5 pt-md-0'
									)}
								>
									<iframe
										className={styles.video}
										src={caseStudy.media}
										frameBorder="0"
										allow="autoplay; encrypted-media"
										allowFullScreen
										title="video"
									/>
									<img className={styles.bgImage} src={VideoBackgroundImage} />
								</div>
							</div>
						</WidthContainer>
					</PaddingContainer>
				) : (
					<DescriptionWithImage
						key={caseStudy.title}
						imageClassName={styles.image}
						disableContentPadding
						imageOnRight
						image={caseStudy.media}
					>
						<div className="pr-lg-5">
							<img
								className="mb-3"
								src={caseStudy.leadingIcon}
								alt={caseStudy.title}
							/>
							<p className="font-size-md font-600 orange-font mb-2">
								{caseStudy.title}
							</p>
							<p className="font-size-sm line-height-26 limit-text mb-3">
								{caseStudy.description}
							</p>
							<Link
								className={classNames(
									styles.link,
									'bttn bttn-orange-border link'
								)}
								to={caseStudy.link}
							>
								See case study with this technology
							</Link>
						</div>
					</DescriptionWithImage>
				)
			)}
		</div>
	);
};
